<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-group row">
    <label for="name" class="label col-sm-3 col-form-label">
      {{ "input.name.label" | translate }}
    </label>
    <div>
      <input
        type="text"
        nbInput
        fullWidth
        [ngClass]="{ isDisabled: !isEditing }"
        id="name"
        placeholder=" {{ 'input.name.placeholderCompany' | translate }}"
        formControlName="name"
        [status]="showInputError('name') ? 'danger' : 'basic'"
      />
    </div>
  </div>
  <!--  -->
  <div class="form-group row">
    <label for="email" class="label col-sm-3 col-form-label">
      {{ "input.email.label" | translate }}
    </label>
    <div>
      <input
        type="text"
        nbInput
        fullWidth
        [ngClass]="{ isDisabled: true }"
        id="email"
        placeholder="{{ 'input.email.placeholder' | translate }}"
        formControlName="email"
        [status]="showInputError('email') ? 'danger' : 'basic'"
      />
    </div>
  </div>

  <div class="group">
    <div class="form-group row">
      <label for="role" class="label col-sm-3 col-form-label">
        {{ "input.role.label" | translate }}
      </label>
      <div>
        <input
          type="text"
          nbInput
          fullWidth
          [ngClass]="{ isDisabled: true }"
          id="role"
          formControlName="role"
          [status]="showInputError('role') ? 'danger' : 'basic'"
          maxlength="13"
        />
      </div>
    </div>
  </div>

  <div class="actions">
    <button
      *ngIf="isEditing"
      type="button"
      nbButton
      status="danger"
      outline
      (click)="cancelEdit()"
    >
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      *ngIf="isEditing"
      type="submit"
      nbButton
      status="primary"
      [nbSpinner]="saving"
      nbSpinnerStatus="control"
      [disabled]="saving"
    >
      {{ "buttons.save" | translate }}
    </button>
    <button
      *ngIf="!isEditing"
      type="button"
      nbButton
      outline
      status="primary"
      (click)="isEditing = true"
    >
      {{ "buttons.edit" | translate }}
    </button>
  </div>
</form>

<!-- Email change: admins only, new address must be confirmed via mailed link -->
<ng-container *ngIf="isAdmin">
  <form
    class="email-change"
    *ngIf="isEditingEmail"
    [formGroup]="emailForm"
    (ngSubmit)="onEmailSubmit()"
  >
    <div class="form-group row">
      <label for="new_email" class="label col-sm-3 col-form-label">
        {{ "pages.settings.emailChange.newEmail" | translate }}
      </label>
      <div>
        <input
          type="email"
          nbInput
          fullWidth
          id="new_email"
          placeholder="{{ 'input.email.placeholder' | translate }}"
          formControlName="new_email"
          [status]="showEmailInputError('new_email') ? 'danger' : 'basic'"
        />
      </div>
    </div>
    <div class="form-group row">
      <label for="confirm_email" class="label col-sm-3 col-form-label">
        {{ "pages.settings.emailChange.repeatEmail" | translate }}
      </label>
      <div>
        <input
          type="email"
          nbInput
          fullWidth
          id="confirm_email"
          placeholder="{{ 'input.email.placeholder' | translate }}"
          formControlName="confirm_email"
          [status]="showEmailInputError('confirm_email') ? 'danger' : 'basic'"
        />
      </div>
    </div>
    <div class="form-group row">
      <label for="email_current_password" class="label col-sm-3 col-form-label">
        {{ "input.currentPassword.label" | translate }}
      </label>
      <div>
        <input
          type="password"
          nbInput
          fullWidth
          id="email_current_password"
          formControlName="current_password"
          [status]="
            showEmailInputError('current_password') ? 'danger' : 'basic'
          "
        />
      </div>
    </div>
    <p class="email-hint">
      {{ "pages.settings.emailChange.hint" | translate }}
    </p>
  </form>

  <p class="email-pending" *ngIf="pendingEmail">
    {{ "pages.settings.emailChange.pending" | translate : { email: pendingEmail } }}
  </p>

  <div class="actions">
    <button
      *ngIf="isEditingEmail"
      type="button"
      nbButton
      status="danger"
      outline
      (click)="cancelEmailEdit()"
    >
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      *ngIf="isEditingEmail"
      type="button"
      nbButton
      status="primary"
      [nbSpinner]="emailSaving"
      nbSpinnerStatus="control"
      [disabled]="emailSaving"
      (click)="onEmailSubmit()"
    >
      {{ "buttons.save" | translate }}
    </button>
    <button
      *ngIf="!isEditingEmail"
      type="button"
      nbButton
      outline
      status="primary"
      (click)="startEmailEdit()"
    >
      {{ "pages.settings.emailChange.editButton" | translate }}
    </button>
  </div>
</ng-container>
